import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import { getPropertyThumbnail } from '../../helpers/images';
import styles from './ChatCard.module.scss';

export interface Props {
  chatId: string;
  imageUrl?: string;
  message?: string;
  isNewMessage: boolean;
  name: string;
  time?: string;
  isSelected?: boolean;
  isSeller: boolean;
  property: any;
}

export default function ChatCard(props: Props) {
  return (
    <Link
      to={`/messages/${props.chatId}`}
      className={clsx(styles.container, props.isSelected && styles.isSelected)}
    >
      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${getPropertyThumbnail(
            props.property?.attaches
          )})`,
        }}
      />

      <div className={styles.content}>
        <h2>{props.property?.address?.name}</h2>
        {props.property?.address?.city && props.property?.address?.state && (
          <p>
            {props.property?.address?.city}, {props.property?.address?.state}
          </p>
        )}
        <p>
          <b>{props.isSeller ? 'Comprador' : 'Vendedor'}: </b>
          {props.name}
        </p>

        <p>
          <b>{props.isNewMessage ? '¡Nuevo mensaje!' : ''}</b>
        </p>

        {props.time && <span>{props.time}</span>}
      </div>
    </Link>
  );
}
